document.addEventListener("DOMContentLoaded", function () {
  const header = document.querySelector('header'); // Or document.getElementById('yourHeaderId');
  const menuDrawer = document.querySelector('.menu-drawer'); // Select the menu drawer element

  if (header && menuDrawer) {
      const rect = header.getBoundingClientRect();
      const headerBottomPosition = rect.bottom;

      // Set the CSS Custom Property directly on the .menu-drawer element
      menuDrawer.style.setProperty('--header-bottom-position', `${headerBottomPosition}px`);

      console.log("Header bottom position set as CSS variable --header-bottom-position on .menu-drawer:", headerBottomPosition + "px");
  } else {
      console.log("Header or .menu-drawer element not found. Could not set --header-bottom-position.");
  }

  // Initialize Swiper for Hero Banner
  const stickyButtons = document.querySelector(".block__mobile-sticky-buttons");
  if (window.innerWidth < 991 && stickyButtons) {
    const height = stickyButtons.offsetHeight;
    document.body.style.paddingBottom = height + "px";
  }

  // Cursor JS
  // const circle = document.querySelector('.circle');
  // const follow = document.querySelector('.circle-follow');

  // window.addEventListener('mousemove', (e) => {
  //   const target = e.target;

  //   // Animate the position
  //   gsap.to(circle, { duration: 0.3, x: e.clientX, y: e.clientY });
  //   gsap.to(follow, { duration: 0.7, x: e.clientX, y: e.clientY });

  //   // Check if hovered element is clickable
  //   const isClickable = target.closest(`
  //       a, button, [onclick], [role="button"], [tabindex]:not([tabindex="-1"]), [aria-pressed], input, select, textarea,
  //       .block__our-expertise-question
  //   `);

  //   // Toggle grow class
  //   if (isClickable) {
  //     follow.classList.add('grow');
  //   } else {
  //     follow.classList.remove('grow');
  //   }
  // });

});

document.addEventListener("DOMContentLoaded", () => {
  function matchHeight(containerClass, gridClass, titleClass, desktopGrid, mobileGrid) {
    const containers = document.getElementsByClassName(containerClass);
    if (!containers.length) return;

    const screenWidth = document.documentElement.clientWidth;
    const itemsPerRow = screenWidth > 769 ? desktopGrid : mobileGrid;

    for (let c = 0; c < containers.length; c++) {
      const container = containers[c];
      const gridItems = container.getElementsByClassName(gridClass);

      // Reset min-heights
      for (let item of gridItems) {
        const titleEl = item.getElementsByClassName(titleClass)[0];
        if (titleEl) titleEl.style.minHeight = 'auto';
      }

      for (let i = 0; i < gridItems.length; i += itemsPerRow) {
        let maxHeight = 0;
        // Find max height in the current row
        for (let j = i; j < i + itemsPerRow && j < gridItems.length; j++) {
          const titleEl = gridItems[j].getElementsByClassName(titleClass)[0];
          if (titleEl) {
            const height = titleEl.offsetHeight;
            if (height > maxHeight) maxHeight = height;
          }
        }
        // Set max height to all items in the current row
        for (let j = i; j < i + itemsPerRow && j < gridItems.length; j++) {
          const titleEl = gridItems[j].getElementsByClassName(titleClass)[0];
          if (titleEl) titleEl.style.minHeight = `${maxHeight}px`;
        }
      }
    }
  }

  matchHeight(
    'block__our-services-content-wrapper',
    'block__our-services-content-detailed',
    'block__our-services-content--title',
    2,
    1
  );
  matchHeight(
    'block__our-services-content-wrapper',
    'block__our-services-content-detailed',
    'block__our-services-content--caption',
    2,
    1
  );
  matchHeight(
    'block__content-with-btn--contents',
    'block__content-with-btn--content-box',
    'block__content-with-btn--title',
    3,
    1
  );
  matchHeight(
    'block__content-with-btn--contents',
    'block__content-with-btn--content-box',
    'block__content-with-btn--description',
    3,
    1
  );

  window.addEventListener('resize', () => {
    matchHeight(
      'block__our-services-content-wrapper',
      'block__our-services-content-detailed',
      'block__our-services-content--title',
      2,
      1
    );
    matchHeight(
      'block__our-services-content-wrapper',
      'block__our-services-content-detailed',
      'block__our-services-content--caption',
      2,
      1
    );
    matchHeight(
      'block__content-with-btn--contents',
      'block__content-with-btn--content-box',
      'block__content-with-btn--title',
      3,
      1
    );
    matchHeight(
      'block__content-with-btn--contents',
      'block__content-with-btn--content-box',
      'block__content-with-btn--description',
      3,
      1
    );
  });
});